import { render, staticRenderFns } from "./CannedResponseTable.vue?vue&type=template&id=0fc4d36a&"
import script from "./CannedResponseTable.vue?vue&type=script&lang=js&"
export * from "./CannedResponseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports